import React from 'react';
import { TotalRegister } from '../../../../../components/TotalRegister';
import Pagination from 'components/Pagination';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import Loader from 'react-loader-spinner';
import { ListGroup, ListGroupItem, Row } from 'reactstrap';
import { useSelector } from 'react-redux';
import { Col } from 'react-bootstrap';

const Table = ({
  protocols,
  protocolOverallSLAInfo,
  formatColumn,
  loading,
  quantity,
  activePage,
  handlePageChange,
  itemsPerPage,
  setOrderByColumn,
  orderByColumn,
  sortDirection,
  setSortDirection,
  isRecordTypeUsingSLA = false
}) => {
  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const itemStyle = { padding: '5px 0 0 20px' };

  const handleClick = (column) => {
    let newSortDirection = 'ASC';

    if (orderByColumn === column) {
      newSortDirection = sortDirection === 'ASC' ? 'DESC' : 'ASC';
      setSortDirection(newSortDirection);
    } else {
      setOrderByColumn(column);
      setSortDirection('ASC');
    }

    orderByColumn === column ? setOrderByColumn('') : setOrderByColumn(column);
  };
  const addSortFunctionsToTheColumnThatCanBeSortable = () => {
    return formatColumn().map((column) => {
      if (column?.sort) {
        return {
          ...column,
          headerStyle: {
            ...column.headerStyle,
            cursor: 'pointer'
          },
          onSort: () => handleClick(column.dataField)
        };
      }
      return column;
    });
  };

  return (
    <>
      {quantity > 0 ? (
        <>
          {quantity >= 0 && <TotalRegister totalRegister={quantity} />}
          <ToolkitProvider
            data={protocols}
            keyField="id"
            columns={addSortFunctionsToTheColumnThatCanBeSortable()}
          >
            {(props) => (
              <div className="py-4 table-responsive">
                {loading ? (
                  <Row className="justify-content-md-center">
                    <Loader
                      type="TailSpin"
                      color={systemConfiguration.primary_color}
                      height={100}
                      width={100}
                    />
                  </Row>
                ) : (
                  <BootstrapTable
                    {...props.baseProps}
                    bootstrap4={false}
                    bordered={false}
                  />
                )}
              </div>
            )}
          </ToolkitProvider>
          <Pagination
            itemsCountPerPage={itemsPerPage}
            activePage={activePage}
            totalItemsCount={quantity}
            onChange={handlePageChange.bind(this)}
          />
          {protocolOverallSLAInfo && isRecordTypeUsingSLA && (
            <Row className="mb-3 mt-3">
              <Col md="3">
                <ListGroup flush>
                  <ListGroupItem disabled style={itemStyle}>
                    <span style={{ fontSize: '13px', fontWeight: 'bold' }}>
                      Protocolos conformes:
                    </span>{' '}
                    {protocolOverallSLAInfo.conformingProtocols || 0}
                  </ListGroupItem>
                  <ListGroupItem disabled style={itemStyle}>
                    <span style={{ fontSize: '13px', fontWeight: 'bold' }}>
                      Protocolos não conformes:
                    </span>{' '}
                    {protocolOverallSLAInfo.nonConformingProtocols || 0}
                  </ListGroupItem>
                  <ListGroupItem disabled style={itemStyle}>
                    <span style={{ fontSize: '13px', fontWeight: 'bold' }}>
                      Média de Atendimento:
                    </span>{' '}
                    {protocolOverallSLAInfo.averageSLAServiceTime !== null
                      ? `${protocolOverallSLAInfo.averageSLAServiceTime}%`
                      : 'N/A'}
                  </ListGroupItem>
                  <ListGroupItem disabled style={itemStyle}>
                    <span style={{ fontSize: '13px', fontWeight: 'bold' }}>
                      Média de Solução:
                    </span>{' '}
                    {protocolOverallSLAInfo.averageSLASolutionTime !== null
                      ? `${protocolOverallSLAInfo.averageSLASolutionTime}%`
                      : 'N/A'}
                  </ListGroupItem>
                </ListGroup>
              </Col>
            </Row>
          )}
        </>
      ) : null}
    </>
  );
};

export default Table;
